<template>
  <li>
    <h2 class="h3">Exceeding Graduates</h2>

    <div class="row">
      <div class="col-lg-4">
        <div class="form-group">
          <label class="control-label">Program</label>
          <multiselect
            @input="handleSelectProgramCallback"
            :value="programSelected"
            :options="programs"
            track-by="id"
            label="name"
            v-validate="'required'"
            name="program"
            data-vv-validate-on="input|blur"
            :allow-empty="false"
            :searchable="true"
            :show-labels="false"
            :class="[errorClass('program'), validClass('program')]"
            placeholder/>

            <help-block field="program"/>
        </div><!-- /.form-group -->
      </div>

      <div class="offset-lg-4 col-lg-4 text-right">
        <ladda-button :click="handleGenerateReport" :validate="true" class="btn btn-info mt-label">
          <font-awesome :icon="['far', 'file-spreadsheet']"/> Download CSV
        </ladda-button>
      </div>
    </div><!-- /.row -->
  </li>
</template>

<script>
import { programComputed } from 'vx/helpers'
import { http } from 'utils'
import moment from 'moment'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },

  data () {
    return {
      params: {
        program_id: null
      },
      programSelected: null
    }
  },

  computed: {
    ...programComputed
  },

  methods: {
    handleSelectProgramCallback (program) {
      this.programSelected = program

      this.params.program_id = program
        ? program.id
        : null
    },

    async handleGenerateReport () {
      let params = this.params

      return http.get(`reports/exceeding`, { responseType: 'blob', params }).then(response => {
        let now = moment().format('DD-MM-YYYY-HH-mm')

        let filename = `exceeding-graduates-${now}.csv`

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(response.data, filename)
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')

          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        }
        return response
      })
    }
  }
}
</script>
